export default {
  cols: 12,
  breakpoints: {
    medium: '481px',
    large: '1025px',
  },
  gutter: '15px',
};
